module.exports = __webpack_public_path__ + "static/media/ddex.941784ff.png";